import Svg, { Path } from "react-native-svg"

const ChatbotIcon = ({ height, width, color }) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 20 16"
      fill="none"
    >
      <Path
        d="M13.007 5.5c0 3.063-2.935 5.5-6.494 5.5-1.218 0-2.31-.25-3.279-.75-.78.406-1.78.75-2.997.75-.093 0-.187-.031-.218-.125-.032-.094-.032-.188.062-.25 0-.031.718-.781 1.218-1.813C.487 7.875.019 6.75.019 5.5.019 2.469 2.922 0 6.513 0c3.559 0 6.494 2.469 6.494 5.5zM6.513 9c.437 0 .749-.313.749-.75a.722.722 0 00-.75-.75.722.722 0 00-.749.75c0 .438.313.75.75.75zm1.654-3.625c.531-.313.843-.875.843-1.438A1.68 1.68 0 007.324 2.25H6.076c-.937 0-1.655.75-1.655 1.688 0 .312.25.562.562.562a.56.56 0 00.562-.563c0-.28.25-.53.53-.53h1.25c.28 0 .53.25.53.53 0 .188-.094.344-.28.47l-1.343.812c-.188.093-.281.281-.281.5v.375c0 .312.25.562.562.562a.56.56 0 00.562-.562V6.03l1.092-.656zm10.553 8.5c.5 1 1.186 1.719 1.186 1.75a.243.243 0 01.063.25c-.031.094-.125.125-.219.125-1.124 0-2.092-.313-2.872-.656a6.689 6.689 0 01-2.872.656c-2.841 0-5.183-1.75-5.839-4.156 3.34-.656 5.839-3.25 5.839-6.344 0-.156-.032-.313-.032-.469 0 0 0-.031.032-.031C17.315 5 20 7.469 20 10.5c0 1.281-.5 2.438-1.28 3.375zm-1.78-3.938c.25-.25.219-.624-.03-.874-.25-.25-.625-.22-.875.03l-2.185 2.282-.781-.813a.707.707 0 00-.905 0 .708.708 0 000 .907l1.248 1.25a.767.767 0 00.469.156.616.616 0 00.437-.188l2.622-2.75z"
        fill={color}
      />
    </Svg>
  )
}

export default ChatbotIcon